













































































import Component from 'vue-class-component'
import Vue from 'vue'
import Card from '../../../../../../components/Card.vue'
import { ETableColumnType, ITableConfig } from '../../../../../../interfaces'
import {
  EFacilityMonthlyBillingBatchStatus,
  EZuntaInvoiceStatus,
  EZuntaInvoiceType,
  IFacility,
  IZuntaInvoice
} from '@zunta/configurations'
import Table from '@/components/tables/Table.vue'
import Icon from '@/components/Icon.vue'
import Status from '@/components/statuses/Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import { getStatementPathByKey } from '@/utils/helpers'
import BillingHistoryModal from '@/views/app/admin/pages/billing/pages/components/BillingHistoryModal.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { getModule } from 'vuex-module-decorators'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
// @ts-ignore
import Teleport from 'vue2-teleport'

@Component({
  components: {
    ButtonDownloadReport,
    BillingHistoryModal,
    Status,
    Icon,
    Table,
    Card,
    Teleport
  }
})
export default class InvoicePageTab extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  historyInvoiceId: number | null = null
  shouldShowBillingHistory: boolean = false

  prevInvoicesFilters: any = {
    limit: 20,
    skip: 0
  }

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    rowClick: this.openInvoicePdf,
    fetchFunction: this.fetchInvoices,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1.5rem - 1px); right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    columns: [
      {
        minWidth: '250px',
        width: 20,
        key: 'chainFacility',
        searchKey: 'chainFacility',
        hasSort: true,
        hasSearch: true,
        label: 'Chain/Facility',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 8,
        key: 'invoiceDate',
        searchKey: 'dateRange',
        hasSort: true,
        hasSearch: true,
        label: 'Invoice Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '150px',
        width: 7,
        key: 'invoiceType',
        searchKey: 'invoiceType',
        hasSearch: true,
        hasSort: true,
        label: 'Invoice Type',
        type: ETableColumnType.select,
        options: [
          {
            key: 'monthly',
            content: 'Monthly',
            value: EZuntaInvoiceType.MONTHLY
          },
          {
            key: 'cc',
            content: 'Credit Card',
            value: EZuntaInvoiceType.CC
          },
          {
            key: 'eCheck',
            content: 'eCheck',
            value: EZuntaInvoiceType.ECHECK
          },
          {
            key: 'mailing',
            content: 'Mailing',
            value: EZuntaInvoiceType.MAILING
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 8,
        key: 'amount',
        searchKey: 'amount',
        hasSort: true,
        hasSearch: true,
        label: 'Amount',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 9.5,
        key: 'cost',
        searchKey: 'cost',
        hasSort: true,
        hasSearch: true,
        label: 'Cost',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 10.5,
        key: 'net',
        searchKey: 'net',
        hasSort: true,
        hasSearch: true,
        label: 'Net',
        type: ETableColumnType.default
      },
      {
        minWidth: '170px',
        width: 17,
        key: 'status',
        searchKey: 'status',
        hasSearch: true,
        hasSort: true,
        label: 'Invoice Status',
        type: ETableColumnType.select,
        options: [
          {
            key: 'paid',
            content: 'Paid',
            value: EZuntaInvoiceStatus.PAID
          },
          {
            key: 'Unbilled',
            content: 'Unbilled',
            value: EZuntaInvoiceStatus.NOT_PAID
          },
          {
            key: 'no-payment-method',
            content: 'No Payment Method',
            value: EZuntaInvoiceStatus.NO_PAYMENT_METHOD
          },
          {
            key: 'rejected-payment',
            content: 'Rejected Payment',
            value: EZuntaInvoiceStatus.REJECTED
          },
          {
            key: 'refund',
            content: 'Refund',
            value: EZuntaInvoiceStatus.REFUND
          }
        ]
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'isDiscrepancy',
        searchKey: 'isDiscrepancy',
        hasSearch: true,
        hasSort: true,
        label: 'Discrepancy',
        type: ETableColumnType.select,
        options: [
          {
            key: 'yes',
            content: 'Yes',
            value: 'true'
          },
          {
            key: 'no',
            content: 'No',
            value: 'false'
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'actions',
        type: ETableColumnType.default
      }
    ]
  }

  get invoices () {
    return this.$store.state.chain.billingInvoices
  }

  get totalInvoices () {
    return this.$store.state.chain.totalInvoices
  }

  get userId () {
    return this.$route.params.userId
  }

  getStatusType (status: string): EStatusType {
    switch (status) {
      case EFacilityMonthlyBillingBatchStatus.PAID:
        return EStatusType.success
      default:
        return EStatusType.default
    }
  }

  getInvoiceTypeLabel (type: EZuntaInvoiceType) {
    switch (type) {
      case EZuntaInvoiceType.CC:
        return 'Credit Card'
      case EZuntaInvoiceType.ECHECK:
        return 'eCheck'
      case EZuntaInvoiceType.MAILING:
        return 'Mailing'
      case EZuntaInvoiceType.MONTHLY:
        return 'Monthly'
      default:
        return 'Unknown Type'
    }
  }

  getInvoiceStatusLabel (status: EZuntaInvoiceStatus) {
    switch (status) {
      case EZuntaInvoiceStatus.NOT_PAID:
        return 'Unbilled'
      case EZuntaInvoiceStatus.NO_PAYMENT_METHOD:
        return 'No Payment Method'
      case EZuntaInvoiceStatus.PAID:
        return 'Paid'
      case EZuntaInvoiceStatus.REJECTED:
        return 'Rejected Payment'
      case EZuntaInvoiceStatus.REFUND:
        return 'Refund'
      default:
        return 'Unknown Status'
    }
  }

  mounted () {
    this.$watch('$route', (oldVal, newVal) => {
      if (this.$refs.table && oldVal.params.name === newVal.params.name) {
        // @ts-ignore
        this.$refs.table.initSearch()
      }
    })
  }

  async fetchInvoices (filters: any) {
    const localFilters = { ...filters }
    this.prevInvoicesFilters = filters
    if (this.userId) {
      localFilters.user = this.userId
    }
    await this.chainModuleInstance.getBillingInvoices(localFilters)
  }

  openInvoicePdf (item: IZuntaInvoice) {
    if (item.pdf) {
      const facility: IFacility = item.facility as IFacility
      const name = `${(facility.shortName || facility.name).replace(/( |\s)/g, '_')}-${this.getInvoiceTypeLabel(item.type).replace(/( |\s)/g, '-')}-${new Date(item.invoiceDate).toLocaleDateString()}`.replace(/(\/|\\)/g, '.')
      window.open(getStatementPathByKey(item.pdf, name))
    }
  }

  showHistory (invoiceId: number) {
    this.historyInvoiceId = invoiceId
    this.shouldShowBillingHistory = true
  }
}
